import { P } from 'ia-react-core';
import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ChangePasswordContext from '../../../../utils/ChangePasswordContext';
import { StyledPasswordStrength } from './PasswordStrengthLabel.styles';

export interface PasswordStrengthLabelProps { }

const PasswordStrengthLabel: FC<PasswordStrengthLabelProps> = () => {
  const { t } = useTranslation('ChangePasswordSection');
  const { rules } = useContext(ChangePasswordContext);

  return (
    <P>{t('PasswordStrength')}<StyledPasswordStrength strength={rules?.PasswordStrengthClass}>{t(rules?.PasswordStrength)}</StyledPasswordStrength></P>);
};

export default PasswordStrengthLabel;
